<template>
  <div>
    <div
      v-if="gettingData"
      class="d-flex flex-column align-items-center mt-8 py-6 loadingicon text-center"
    >
      <atom-spinner :animation-duration="1000" :size="80" :color="'#6200ea'" />
      <p class="font-weight-bold mt-4" style="color: #6200ea">
        در حال بارگذاری اطلاعات...
      </p>
    </div>
    <v-card class="common-card-panel" v-else>
      <v-row>
        <v-col lg="12" md="12" sm="12" xs="12">
          <v-row>
            <v-col xl="10" lg="10" md="9" sm="6" xs="12" cols="12">
              <div class="title-card-employee">
                <h4 class="title_sub_card">فروش‌های نقدی و اقساطی</h4>
              </div>
            </v-col>
            <v-col xl="2" lg="2" md="3" sm="6" xs="12" cols="12">
              <v-btn
                v-if="isStatusRegistered"
                @click="goToPrint"
                :disabled="selectedRows.length === 0"
                block
                class="purple-mainBtn"
              >
                برچسب پستی
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="date_picker pb-0" md="5" cols="12">
          <label class="title-form-panel"> <span>تاریخ شروع:</span></label>
          <span id="startDate">
            <v-text-field
              outlined
              dense
              type="text"
              append-icon="mdi-calendar-edit"
              v-model="selectedStartDate"
              label="تاریخ شروع"
              placeholder="تاریخ شروع"
              :editable="true"
              class="date-input"
            >
            </v-text-field>
          </span>
          <date-picker
            element="startDate"
            v-model="selectedStartDate"
            color="#6200ea"
          >
          </date-picker>
        </v-col>
        <v-col class="date_picker pb-0" md="5" cols="12">
          <label class="title-form-panel"><span>تاریخ پایان:</span></label>
          <span id="endDate">
            <v-text-field
              outlined
              dense
              type="text"
              append-icon="mdi-calendar-edit"
              v-model="selectedEndDate"
              placeholder="تاریخ پایان"
              label="تاریخ پایان"
              :editable="true"
              class="date-input"
            >
            </v-text-field>
          </span>

          <date-picker
            v-model="selectedEndDate"
            element="endDate"
            color="#6200ea"
          />
        </v-col>
        <v-col class="date_picker pb-0 mt-7" md="2" cols="12">
          <v-btn
            variant="flat"
            block
            class="primary white--text"
            :loading="loading"
            @click="getDateInovices()"
            style="width: 90%"
          >
            فیلتر براساس بازه زمانی
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col lg="6" md="12">
          <v-text-field
            dense
            outlined
            density="compact"
            variant="outlined"
            v-model="filter"
            placeholder="جستجو در کد فروش..."
          ></v-text-field>
        </v-col>
        <v-col lg="3" md="6">
          <v-select
            dense
            outlined
            :items="typeOptions"
            v-model="typeFilter"
            density="compact"
            variant="solo"
            menu-icon="mdi-menu-down"
          ></v-select>
        </v-col>
        <v-col lg="3" md="6">
          <v-select
            dense
            outlined
            :items="statusOptions"
            v-model="statusFilter"
            density="compact"
            variant="solo"
            menu-icon="mdi-menu-down"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col lg="12" md="12">
          <v-data-table
            :headers="tableHeaders"
            :items="computedResults"
            :search="searchField"
            :page.sync="currentPage"
            :items-per-page="perPage"
            :expanded.sync="expanded"
            no-results-text="موردی برای نمایش وجود ندارد!"
            hide-default-footer
            item-key="id"
            :loading="gettingData"
            loading-text="در حال بارگذاری اطلاعات..."
          >
            <template slot="no-data">
              <div class="font-weight-bold">موردی برای نمایش وجود ندارد!</div>
            </template>

            <!--index-->
            <template v-slot:[`item.index`]="{ index }">
              {{ index + perPage * (currentPage - 1) + 1 }}
            </template>
            <template v-slot:[`item.shopCustomerName`]="{ item }">
              <a
                :href="'/shop/customer/' + item.shopCustomerId"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ item.shopCustomerName }}
              </a>
            </template>
            <template v-slot:[`item.totalPayablePrice`]="{ item }">
              <div>
                {{ Number(item.totalPayablePrice).toLocaleString() }}
              </div>
            </template>
            <!-- actions -->
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                v-if="expanded.some((x) => x.id == item.id)"
                @click="toggleExpand(item)"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else @click="toggleExpand(item)"
                >mdi-chevron-down</v-icon
              >
            </template>
            <template v-slot:[`item.select`]="{ item }">
              <v-checkbox
                :input-value="selectedRows.includes(item)"
                @change="toggleRowSelection(item)"
              ></v-checkbox>
            </template>
            <!-- expanded row -->
            <template v-slot:[`expanded-item`]="{ headers, item }">
              <td
                :colspan="headers.length"
                class="text-center d-none d-sm-table-cell"
              >
                <div class="py-2">
                  <v-btn
                    color="blue"
                    class="text-center text-white me-7"
                    @click="openInvoiceDetails(item.id)"
                  >
                    جزییات
                  </v-btn>

                  <!-- <v-btn
                    v-if="item.readyToShip"
                    color="success"
                    class="text-center"
                    @click="send(item)"
                    :disabled="item.isShipped"
                  >
                    ارسال کالا
                  </v-btn> -->

                  <!-- <v-btn
                    v-if="
                      item.status === 'ثبت شده' &&
                      !item.readyToShip &&
                      item.type === 'قسطی'
                    "
                    primary
                    color="success"
                    class="text-center"
                    @click="openChequeDialog(item)"
                  >
                    ثبت اطلاعات چک
                  </v-btn> -->
                </div>
              </td>
            </template>
          </v-data-table>

          <!-- Pagination -->
          <v-pagination
            v-model="currentPage"
            :length="Math.ceil(computedResults.length / perPage)"
            :total-visible="5"
            prev-icon="mdi-arrow-left"
            next-icon="mdi-arrow-right"
            class="mt-8"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-card>
    <!--Cheque-->
    <v-dialog v-model="chequeDialog" width="600px">
      <v-card>
        <v-card-title
          class="d-flex justify-space-between"
          style="background: #fff; color: #000"
        >
          <div>
            <span class="me-1"> ثبت اطلاعات چک </span>
            <span
              @click="openInvoiceDetails(selectedInvoice.id)"
              style="color: #000; cursor: pointer"
              >{{ selectedInvoice.invoiceCode }}</span
            >
          </div>
          <div>
            <v-icon
              style="color: red; font-size: 20px"
              @click="chequeDialog = false"
              >mdi-close</v-icon
            >
          </div>
        </v-card-title>
        <hr />
        <v-card-text>
          <div v-for="(item, index) in selectedCheque" :key="item.id">
            <v-row>
              <v-col md="6" cols="12"
                >مبلغ چک: {{ selectedCheque[index].amount }}</v-col
              >
              <v-col md="6" cols="12"
                >تاریخ چک: {{ selectedCheque[index].chequeDate }}</v-col
              >
              <v-col md="6" cols="12">
                <v-text-field
                  :disabled="selectedCheque[index].chequeStatus == 'ثبت شده'"
                  density="compact"
                  variant="outlined"
                  v-model="selectedCheque[index].chequeNo"
                  placeholder="شماره چک"
                ></v-text-field>
              </v-col>
              <v-col md="6" cols="12">
                <v-text-field
                  :disabled="selectedCheque[index].chequeStatus == 'ثبت شده'"
                  density="compact"
                  variant="outlined"
                  v-model="selectedCheque[index].chequeBank"
                  placeholder="شعبه بانک"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-end pb-4">
              <v-btn
                color="success"
                :disabled="
                  !selectedCheque[index].chequeBank ||
                  !selectedCheque[index].chequeNo ||
                  selectedCheque[index].chequeStatus == 'ثبت شده'
                "
                @click="submitCheque(index)"
                class="me-3"
                >ثبت چک</v-btn
              >
            </v-row>
            <v-divider class="my-3"></v-divider>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--Send-->
    <v-dialog v-model="openSendDialog" width="400">
      <v-card>
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                ارسال کالا
              </h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2">
              <span class="pointer" @click="openSendDialog = false"
                ><v-icon>mdi-close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-0 pt-0" />
        <v-textarea
          class="pa-3 pb-0"
          outlined
          placeholder="در صورت تمایل توضیحات خود را وارد نمایید"
          v-model="sendDescription"
        >
        </v-textarea>
        <div class="text-left pe-3 pb-4 pt-0 d-flex justify-end">
          <v-btn color="success" class="me-3" @click="confirmSend()">
            تایید
          </v-btn>
          <v-btn color="error" @click="openSendDialog = false"> بستن </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Axios from "axios";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";
import { AtomSpinner } from "epic-spinners";
export default {
  name: "CashSales",
  components: {
    AtomSpinner,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      selectedCheque: [],
      expanded: [],
      moment: moment,
      currentPage: 1,
      perPage: 10,
      loading: false,
      opened: [],
      typeOptions: ["همه فروش‌ها", "قسطی", "قطعی"],
      statusOptions: [
        "همه وضعیت‌ها",
        "لغو شده",
        "برگشت خورده",
        "ثبت شده",
        "ارسال شده",
      ],
      invoices: [],
      filter: "",
      typeFilter: "همه فروش‌ها",
      statusFilter: "همه وضعیت‌ها",
      selectedSort: "جدیدترین",
      gettingData: false,
      currentDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      startDate: "",
      endDate: "",
      selectedStartDate: "",
      selectedEndDate: "",
      chequeDialog: false,
      openSendDialog: false,
      selectedPaid: {},
      sendDescription: "",
      selectedInvoice: {},
      currentPage: 1,
      perPage: 10,
      gettingData: false,
      searchField: "",
      selectedRows: [],
    };
  },
  methods: {
    openInvoiceDetails(id) {
      let link = "/shop/invoice/" + id;
      window.open(link, "_blank");
    },
    goToPrint() {
      const selectedIds = this.selectedRows.map((row) => row.id).join(",");
      this.$router.push({
        name: "MultiPreviewShop",
        params: { ids: selectedIds },
      });
    },
    send(item) {
      this.openSendDialog = true;
      this.selectedPaid = item;
    },
    openChequeDialog(item) {
      this.selectedInvoice = item;
      this.selectedCheque = JSON.parse(JSON.stringify(item.cheques));

      this.chequeDialog = true;
    },

    toggleExpand(item) {
      if (this.expanded[0] === item) {
        this.expanded = [];
      } else {
        this.expanded = [];
        this.expanded.push(item);
      }
    },
    openNewProduct() {
      this.$router.push("addproduct");
    },
    goToId(item) {
      this.$router.push("/shop/editproduct/" + item.id);
    },
    confirmSend() {
      Axios.post(
        this.baseUrl +
          "/satrapp/shop/sales/shipInvoice/" +
          this.selectedPaid.id,
        { description: this.sendDescription },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.selectedPaid.status = "ارسال شده";
            this.selectedPaid = {};
            this.openSendDialog = false;
            this.sendDescription = "";
            if (this.selectedStartDate && this.selectedEndDate) {
              this.getDateInovices();
            } else {
              this.getInovices();
            }
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.openSendDialog = false;
          this.sendDescription = "";
          this.selectedPaid = {};
        });
    },
    calculateReturnAmount(item) {
      Axios.get(
        this.baseUrl + "/satrapp/shop/sales/calculateReturnAmount/" + item.id,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )

        .then((res) => {
          if (res.status == 200) {
            if (this.selectedStartDate && this.selectedEndDate) {
              this.getDateInovices();
            } else {
              this.getInovices();
            }
            this.toast(res.data.message + "success");
          }
        })
        .catch((err) => {
          this.toast("Error: " + err.response.data, "error");
        });
    },
    getInovices() {
      this.gettingData = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/sales/invoices",
        {
          startDate: this.startDate,
          endDate: this.endDate,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )

        .then((res) => {
          if (res.status == 200) {
            this.invoices = res.data;
            this.gettingData = false;
          }
        })
        .catch((err) => {
          this.gettingData = false;
          this.toast(err.response.data, "error");
        });
    },

    submitCheque(id) {
      this.selectedCheque[id].chequeStatus = "ثبت شده";
      Axios.post(
        this.baseUrl +
          "/satrapp/shop/payments/submitCheque/" +
          this.selectedCheque[id].id,
        {
          chequeNo: this.selectedCheque[id].chequeNo,
          chequeBank: this.selectedCheque[id].chequeBank,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.chequeDialog = false;

            if (this.selectedStartDate && this.selectedEndDate) {
              this.getDateInovices();
            } else {
              this.getInovices();
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getDateInovices() {
      this.gettingData = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/sales/invoices",
        {
          startDate: this.selectedStartDate,
          endDate: this.selectedEndDate,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )

        .then((res) => {
          if (res.status == 200) {
            this.invoices = res.data;
            this.gettingData = false;
          }
        })
        .catch((err) => {
          this.gettingData = false;
          this.toast(err.response.data, "error");
        });
    },
    toggleRowSelection(item) {
      const index = this.selectedRows.indexOf(item);
      if (index > -1) {
        this.selectedRows.splice(index, 1);
      } else {
        this.selectedRows.push(item);
      }
    },
  },
  computed: {
    isStatusRegistered() {
      return this.statusFilter === "ثبت شده";
    },
    tableHeaders() {
      let baseHeaders = [
        {
          text: "ردیف",
          sortable: false,
          value: "index",
        },
        {
          text: "کد فروش",
          value: "invoiceCode",
          sortable: false,
          align: "center",
        },
        {
          text: "نام مشتری",
          value: "shopCustomerName",
          sortable: false,
          align: "center",
        },
        {
          text: "جمع قیمت(تومان)",
          value: "totalPayablePrice",
          sortable: false,
          align: "center",
        },
        {
          text: "زمان",
          value: "time",
          sortable: false,
          align: "center",
        },
        {
          text: "تاریخ",
          value: "date",
          sortable: false,
          align: "center",
        },
        {
          text: "نوع",
          value: "type",
          sortable: false,
          align: "center",
        },
        {
          text: "وضعیت",
          value: "status",
          sortable: false,
          align: "center",
        },
        { text: "عملیات", value: "actions", sortable: false, align: "center" },
      ];

      if (this.isStatusRegistered) {
        baseHeaders.unshift({
          text: "",
          value: "select",
          sortable: false,
          align: "center",
        });
      }

      return baseHeaders;
    },
    computedResults() {
      if (this.invoices.length) {
        let filtered;
        filtered = this.invoices.filter(
          (x) =>
            x.invoiceCode &&
            x.invoiceCode.toLowerCase().includes(this.filter.toLowerCase())
        );

        if (this.typeFilter != "همه فروش‌ها")
          filtered = filtered.filter((x) => x.type == this.typeFilter);

        if (this.statusFilter != "همه وضعیت‌ها") {
          filtered = filtered.filter((x) => x.status == this.statusFilter);
        }

        return filtered;
      } else return [];
    },
  },
  mounted() {
    this.startDate = moment(this.currentDate, "jYYYY/jMM/jDD").format("X");
    this.startDate = this.startDate - 7 * 86400;
    this.startDate = moment(this.startDate, "X").format("jYYYY/jMM/jDD");
    this.endDate = this.currentDate;
    this.getInovices();
  },
};
</script>
<style lang="scss">
.page_number_result {
  .v-pagination {
    .v-pagination__list {
      li {
        background: #fff;
        font-weight: 600;
        border: 1px solid #2ba8b0;
        border-radius: 100% !important;
        overflow: hidden;
        box-shadow: none !important;
        font-size: 12px !important;
        color: #2ba8b0;
        width: 36px;
        height: 36px;

        .v-btn {
          width: 36px !important;
          height: 36px !important;

          .v-btn__content {
            display: flex;
            align-items: center !important;
            justify-content: center !important;
          }
        }
      }

      .v-pagination__item--is-active {
        background-color: #2ba8b0 !important;
        border: none !important;
        font-size: 0.8rem !important;
        color: #fff !important;
        border-radius: 100% !important;
        overflow: hidden;
      }
    }
  }
}

.btn_edit_list {
  .v-btn {
    padding: 15px !important;

    .v-btn__content {
      justify-content: center !important;
    }
  }
}

.tabale_employees {
  tbody {
    tr {
      &:nth-child(odd) {
        background: rgba(0, 0, 0, 0.05);
      }

      &:nth-child(even) {
        background: #fff;
      }
    }
  }

  tr {
    th {
      font-size: 14px;
    }

    td {
      font-size: 13px;
    }
  }
}

.darkGreen-mainBtn {
  background-color: #1e6e42;
  color: #fff;
  display: flex;
  justify-content: space-between;
  font-size: 14px !important;
  cursor: pointer;
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
  padding: 15px !important;
}

.line-title-card {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.filter_titile {
  display: flex;
  align-items: center;
  cursor: pointer;

  p {
    color: #656a81;
    font-size: 14px;
    margin-left: 10px;
  }
}

.sort-box {
  border-radius: 10px;
  padding: 7px 15px;

  @media only screen and (max-width: 768px) {
    padding: 11px 15px;
  }

  color: #656a81;
  width: fit-content;
  font-size: 14px;

  &.selected-sort {
    background-color: #00b4d8;
    color: #fff;

    &:hover {
      background-color: #00b4d8;
    }
  }

  &:hover {
    background-color: #eee;
  }
}

.common-card-panel {
  border-radius: 16px !important;
  box-shadow: none !important;
  margin: 20px 0;
  height: 100%;
  padding: 20px;
}

.title_card_panel {
  font-weight: 500;
  font-size: 18px;
  color: #656a81;
  padding-right: 10px;
  padding-top: 10px;
}

.line-title-card {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.title_sub_card {
  font-weight: 600;
  font-size: 18px;
  color: #001ebd;
  margin: 10px 0;
  margin-right: 10px;
}

.btn_employees {
  span {
    color: #19ab4f;
    font-weight: 600;
  }
}

.active-badge,
.deactive-badge {
  border-radius: 50px;
  font-weight: 500;
  padding: 6px 8px;
  font-size: 12px !important;
  border: 1px solid #2a8817;
  background-color: rgba(0, 171, 193, 0.0666666667);
  color: #2a8817 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.deactive-badge {
  border: 1px solid #f3536e !important;
  background-color: #fcf2f4 !important;
  color: #f3536e !important;
}
</style>
